import { Grid } from "@mui/material";
import {
  directCampaignData,
  referralCampaignData,
} from "components/Campaign/CampaignEffects/GivePointsTransactions/data";
import { EffectSearch } from "components/EffectSearch/EffectSearch";
import { useMessage } from "hooks/intl";
import { memo } from "react";

export const GivePointsTransactionBased = memo(
  ({
    fieldName,
    isReferralCampaign,
  }: {
    fieldName: string;
    isReferralCampaign: boolean;
  }) => {
    const { message } = useMessage();

    return (
      <Grid item xs={12}>
        <EffectSearch
          data-test-id="give-points-transaction-based"
          items={isReferralCampaign ? referralCampaignData : directCampaignData}
          name={fieldName}
          placeholder={message({ id: "autocompletePlaceholder" })}
        />
      </Grid>
    );
  },
);
